import React from "react";
import styles from "./index.module.scss";
import ChapterNode from "./components/ChapterNode";
import ChapterHeaders from "./components/ChapterNode/components/ChapterHeader";
import { ChapterTree } from "../../../../../../../../service/CourseDetail/chapter";

interface ChaptersListProps {
    data: ChapterTree[];
}

export default function StuViewChaptersList({ data }: ChaptersListProps) {
    const rootTitle = (
        <ChapterHeaders title={data[0]?.chapterName} percent={0} />
    );

    return (
        <div className={styles.root}>
            <ChapterNode
                title={rootTitle}
                chapters={data[0]?.children || []}
                sources={data[0]?.dcCoursewareSourceList || []}
            />
        </div>
    );
}
